// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../Fuel/font/digital-7.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*media breaks*/
@font-face {
  font-family: "digital-clock-font";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.shift-modal input {
  border-radius: 8px;
  width: 150px;
  border: 1px solid #2c53a0;
  text-align: center;
  height: 2rem;
  padding: 0 4px;
}

.attendance_modal {
  display: flex;
  flex-direction: column;
  align-items: space-between;
  justify-content: space-between;
}
.attendance_modal .attendance_form {
  display: flex;
  flex-direction: column;
}
.attendance_modal .attendance_form h4 {
  margin: 0;
}
.attendance_modal .attendance_form select,
.attendance_modal .attendance_form input {
  border-radius: 5px;
  height: 30px;
}
.attendance_modal .attendance_form textarea {
  max-width: 100%;
  min-width: 100%;
  max-height: 100px;
  min-height: 100px;
  border-radius: 5px;
}
.attendance_modal .attendance_form .sickness_form div,
.attendance_modal .attendance_form .no_show_form div {
  display: flex;
  flex-direction: column;
  margin: 10px 0;
}
.attendance_modal .attendance_form .sickness_form div label,
.attendance_modal .attendance_form .no_show_form div label {
  font-weight: 500;
}
.attendance_modal .alert_section {
  height: 6vh;
  margin: 10px 0;
}
.attendance_modal .btn_section {
  display: flex;
  justify-content: space-between;
  gap: 50px;
  width: 100%;
}
.attendance_modal .btn_section button {
  width: 100%;
}

.edit_shift_modal p {
  text-align: center;
}
.edit_shift_modal .input_section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  margin: 1vh auto;
}
.edit_shift_modal .input_section label {
  font-weight: 700;
  width: 100%;
}
.edit_shift_modal .input_section label span {
  color: #ed6c02;
}
.edit_shift_modal .input_section input,
.edit_shift_modal .input_section select,
.edit_shift_modal .input_section textarea {
  border-radius: 5px;
  height: 4vh;
  width: 100%;
}
.edit_shift_modal .alert_section {
  height: 6vh;
}
.edit_shift_modal .btn_section {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 10px;
}
.edit_shift_modal .btn_section button {
  width: 100%;
}

.main_column {
  display: flex;
  width: 80%;
  justify-content: space-between;
  flex-direction: column;
}

.shift_times_area {
  margin: 10px;
  padding: 10px;
  border: 2px solid grey;
  border-radius: 10px;
  position: relative;
}
.shift_times_area .overtime_icon {
  position: absolute;
  top: 5px;
  right: 5px;
}
.shift_times_area h3 {
  margin: 10px 5px 10px 5px;
  padding: 5px;
}
.shift_times_area .shift_time {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.shift_times_area .shift_time p {
  margin: 10px 5px 10px 5px;
  padding: 5px;
  width: auto;
}
.shift_times_area .shift_time span {
  font-weight: bold;
}
.shift_times_area .shift_time .time_input {
  padding: 10px;
}
.shift_times_area .shift_time .time_input label {
  padding: 10px 10px 0 10px;
}
.shift_times_area .shift_time .time_input input {
  width: 175px;
}

.icon_list {
  border: 2px solid grey;
  border-radius: 10px;
  justify-content: space-evenly;
  justify-items: center;
  display: flex;
}
.icon_list .icon {
  margin: 10px;
  justify-content: center;
  justify-self: center;
}

.side_bar {
  display: flex;
  flex-direction: column;
  width: 20%;
  gap: 15px;
  padding: 10px;
}
.side_bar .worked_breakdown {
  top: 0;
  padding: 10px;
  border: 2px solid grey;
  border-radius: 10px;
}
.side_bar .worked_breakdown span {
  font-weight: bold;
}
.side_bar .worked_breakdown .break {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 2vh;
  margin-bottom: 2vh;
  justify-content: space-between;
}
.side_bar .worked_breakdown .break svg {
  float: right;
  right: 0;
}
.side_bar .worked_breakdown .break p {
  margin: 0;
}
.side_bar .buttons {
  float: right;
  border: 2px solid grey;
  border-radius: 10px;
}
.side_bar .buttons .button {
  width: 90%;
  padding: 10px;
  margin: 1vh;
}

.tabs {
  margin: 10px;
  padding: 10px;
  border: 2px solid grey;
  border-radius: 10px;
}

.tab_panel {
  height: 25vh;
  margin: 10px;
  padding: 10px;
}
.tab_panel input {
  border-radius: 10px;
  width: 150px;
  border: 1px solid #2c53a0;
  text-align: center;
}

.notes_header {
  width: 100%;
  height: 3vh;
  justify-content: space-around;
  position: sticky;
  margin-bottom: 1vh;
  top: 0;
}
.notes_header input {
  height: 2.1rem;
  width: 50%;
  border-radius: 5px;
  margin-right: 5px;
}

.notes_scroll {
  overflow-y: auto;
}

.modal__tables {
  color: "#4d4d4d";
  border: "1px solid #4d4d4d";
  border-collapse: "collapse";
  width: "100%";
  table-layout: "fixed";
}
.modal__tables td {
  text-align: center;
  word-break: break-all;
}
.modal__tables tr:nth-child(even) {
  background-color: #f2f2f2;
}
@media (max-width: 600px) {
  .modal__tables tbody tr td {
    word-break: break-all;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/variables.scss","webpack://./src/components/holidays/rotas/modal/shiftModal.scss"],"names":[],"mappings":"AAOA,eAAA;AAeA;EACI,iCAAA;EACA,4CAAA;ACpBJ;AADI;EACI,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AAGR;;AAAA;EACI,aAAA;EACA,sBAAA;EACA,0BAAA;EACA,8BAAA;AAGJ;AADI;EACI,aAAA;EACA,sBAAA;AAGR;AAFQ;EACI,SAAA;AAIZ;AAFQ;;EAEI,kBAAA;EACA,YAAA;AAIZ;AAFQ;EACI,eAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAIZ;AAAY;;EACI,aAAA;EACA,sBAAA;EACA,cAAA;AAGhB;AAFgB;;EACI,gBAAA;AAKpB;AACI;EACI,WAAA;EACA,cAAA;AACR;AAEI;EACI,aAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;AAAR;AACQ;EACI,WAAA;AACZ;;AAKI;EACI,kBAAA;AAFR;AAKI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAHR;AAIQ;EACI,gBAAA;EACA,WAAA;AAFZ;AAGY;EACI,cAAA;AADhB;AAIQ;;;EAGI,kBAAA;EACA,WAAA;EACA,WAAA;AAFZ;AAKI;EACI,WAAA;AAHR;AAMI;EACI,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,SAAA;AAJR;AAMQ;EACI,WAAA;AAJZ;;AAQA;EACI,aAAA;EACA,UAAA;EACA,8BAAA;EACA,sBAAA;AALJ;;AASA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AANJ;AAQI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;AANR;AASI;EACI,yBAAA;EACA,YAAA;AAPR;AAUI;EACI,aAAA;EACA,mBAAA;EACA,WAAA;AARR;AAUQ;EACI,yBAAA;EACA,YAAA;EACA,WAAA;AARZ;AAWQ;EACI,iBAAA;AATZ;AAYQ;EACI,aAAA;AAVZ;AAYY;EACI,yBAAA;AAVhB;AAaY;EACI,YAAA;AAXhB;;AAiBA;EACI,sBAAA;EACA,mBAAA;EAEA,6BAAA;EACA,qBAAA;EAEA,aAAA;AAhBJ;AAkBI;EACI,YAAA;EACA,uBAAA;EACA,oBAAA;AAhBR;;AAoBA;EACI,aAAA;EACA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;AAjBJ;AAmBI;EACI,MAAA;EACA,aAAA;EAEA,sBAAA;EACA,mBAAA;AAlBR;AAoBQ;EACI,iBAAA;AAlBZ;AAqBQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;AAnBZ;AAqBY;EACI,YAAA;EACA,QAAA;AAnBhB;AAsBY;EACI,SAAA;AApBhB;AAyBI;EACI,YAAA;EACA,sBAAA;EACA,mBAAA;AAvBR;AAyBQ;EACI,UAAA;EACA,aAAA;EACA,WAAA;AAvBZ;;AA8BA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AA3BJ;;AA8BA;EACI,YAAA;EACA,YAAA;EACA,aAAA;AA3BJ;AA+BI;EACI,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AA7BR;;AAkCA;EACI,WAAA;EACA,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;AA/BJ;AAiCI;EACI,cAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;AA/BR;;AAmCA;EACI,gBAAA;AAhCJ;;AAoCA;EACI,gBAAA;EACA,2BAAA;EACA,2BAAA;EACA,aAAA;EACA,qBAAA;AAjCJ;AAmCI;EACI,kBAAA;EACA,qBAAA;AAjCR;AAqCQ;EACI,yBAAA;AAnCZ;AAuCI;EAGY;IACI,qBAAA;EAvClB;AACF","sourcesContent":["$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n\n/*media breaks*/\n$mobile: 600px;\n$tablet: 768px;\n$laptop: 900px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@font-face {\n    font-family: \"digital-clock-font\";\n    src: url(\"./Fuel/font/digital-7.ttf\");\n}\n\n@mixin shadow {\n    box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n@mixin card {\n    background-color: #fff;\n    @include shadow;\n    border-radius: 1rem;\n}\n\n@mixin alertCard {\n    box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px,\n        rgba(0, 0, 0, 0.23) 0px 6px 6px;\n    background-color: #fff;\n    border-radius: 0.5rem;\n}\n\n@mixin eposCard {\n    background-color: #fff;\n    box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px,\n        rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px,\n        rgba(0, 0, 0, 0.09) 0px 32px 16px;\n}\n\n@mixin flex($d: row, $j: center, $a: center, $g: 1vw) {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: $d;\n    justify-content: $j;\n    align-items: $a;\n    gap: $g;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n@mixin columnAlignStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnAlignStartTop {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n@mixin rowEvenStartCenter {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n}\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin table {\n    table-layout: fixed;\n    background-color: #fff;\n    border-collapse: collapse;\n    color: $fontColor;\n    thead {\n        border-bottom: 1px solid $fontColor;\n        text-align: center;\n    }\n    tbody {\n        text-align: center;\n        tr {\n            border-bottom: 1px solid $fontColor;\n            &:nth-child(odd) {\n                background-color: #f2f2f2;\n            }\n            input {\n                width: 20%;\n                margin: 0 auto;\n                text-align: center;\n            }\n        }\n    }\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 50vh;\n    background-color: #fff;\n    border: 2px solid #000;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 600px) {\n        width: 95vw;\n    }\n}\n","@import \"../../../variables.scss\";\n\n.shift-modal {\n    input {\n        border-radius: 8px;\n        width: 150px;\n        border: 1px solid $nitroDark;\n        text-align: center;\n        height: 2rem;\n        padding: 0 4px;\n    }\n}\n.attendance_modal {\n    display: flex;\n    flex-direction: column;\n    align-items: space-between;\n    justify-content: space-between;\n\n    .attendance_form {\n        display: flex;\n        flex-direction: column;\n        h4 {\n            margin: 0;\n        }\n        select,\n        input {\n            border-radius: 5px;\n            height: 30px;\n        }\n        textarea {\n            max-width: 100%;\n            min-width: 100%;\n            max-height: 100px;\n            min-height: 100px;\n            border-radius: 5px;\n        }\n        .sickness_form,\n        .no_show_form {\n            div {\n                display: flex;\n                flex-direction: column;\n                margin: 10px 0;\n                label {\n                    font-weight: 500;\n                }\n            }\n        }\n    }\n\n    .alert_section {\n        height: 6vh;\n        margin: 10px 0;\n    }\n\n    .btn_section {\n        display: flex;\n        justify-content: space-between;\n        gap: 50px;\n        width: 100%;\n        button {\n            width: 100%;\n        }\n    }\n}\n\n.edit_shift_modal {\n    p {\n        text-align: center;\n    }\n\n    .input_section {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 5px;\n        margin: 1vh auto;\n        label {\n            font-weight: 700;\n            width: 100%;\n            span {\n                color: #ed6c02;\n            }\n        }\n        input,\n        select,\n        textarea {\n            border-radius: 5px;\n            height: 4vh;\n            width: 100%;\n        }\n    }\n    .alert_section {\n        height: 6vh;\n    }\n\n    .btn_section {\n        display: flex;\n        justify-content: space-between;\n        flex-direction: column;\n        gap: 10px;\n\n        button {\n            width: 100%;\n        }\n    }\n}\n.main_column {\n    display: flex;\n    width: 80%;\n    justify-content: space-between;\n    flex-direction: column;\n}\n\n// TIME SELECTORS\n.shift_times_area {\n    margin: 10px;\n    padding: 10px;\n    border: 2px solid grey;\n    border-radius: 10px;\n    position: relative;\n\n    .overtime_icon {\n        position: absolute;\n        top: 5px;\n        right: 5px;\n    }\n\n    h3 {\n        margin: 10px 5px 10px 5px;\n        padding: 5px;\n    }\n\n    .shift_time {\n        display: flex;\n        flex-direction: row;\n        width: 100%;\n\n        p {\n            margin: 10px 5px 10px 5px;\n            padding: 5px;\n            width: auto;\n        }\n\n        span {\n            font-weight: bold;\n        }\n\n        .time_input {\n            padding: 10px;\n\n            label {\n                padding: 10px 10px 0 10px;\n            }\n\n            input {\n                width: 175px;\n            }\n        }\n    }\n}\n\n.icon_list {\n    border: 2px solid grey;\n    border-radius: 10px;\n\n    justify-content: space-evenly;\n    justify-items: center;\n\n    display: flex;\n\n    .icon {\n        margin: 10px;\n        justify-content: center;\n        justify-self: center;\n    }\n}\n\n.side_bar {\n    display: flex;\n    flex-direction: column;\n    width: 20%;\n    gap: 15px;\n    padding: 10px;\n\n    .worked_breakdown {\n        top: 0;\n        padding: 10px;\n\n        border: 2px solid grey;\n        border-radius: 10px;\n\n        span {\n            font-weight: bold;\n        }\n\n        .break {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            margin-top: 2vh;\n            margin-bottom: 2vh;\n            justify-content: space-between;\n\n            svg {\n                float: right;\n                right: 0;\n            }\n\n            p {\n                margin: 0;\n            }\n        }\n    }\n\n    .buttons {\n        float: right;\n        border: 2px solid grey;\n        border-radius: 10px;\n\n        .button {\n            width: 90%;\n            padding: 10px;\n            margin: 1vh;\n        }\n    }\n}\n\n// TABS\n\n.tabs {\n    margin: 10px;\n    padding: 10px;\n    border: 2px solid grey;\n    border-radius: 10px;\n}\n\n.tab_panel {\n    height: 25vh;\n    margin: 10px;\n    padding: 10px;\n    // border: 2px solid grey;\n    // border-radius: 10px;\n\n    input {\n        border-radius: 10px;\n        width: 150px;\n        border: 1px solid $nitroDark;\n        text-align: center;\n    }\n}\n\n// NOTES PAGE\n.notes_header {\n    width: 100%;\n    height: 3vh;\n    justify-content: space-around;\n    position: sticky;\n    margin-bottom: 1vh;\n    top: 0;\n\n    input {\n        height: 2.1rem;\n        width: 50%;\n        border-radius: 5px;\n        margin-right: 5px;\n    }\n}\n\n.notes_scroll {\n    overflow-y: auto;\n}\n\n// TAB TABLES\n.modal__tables {\n    color: \"#4d4d4d\";\n    border: \"1px solid #4d4d4d\";\n    border-collapse: \"collapse\";\n    width: \"100%\";\n    table-layout: \"fixed\";\n\n    td {\n        text-align: center;\n        word-break: break-all;\n    }\n\n    tr {\n        &:nth-child(even) {\n            background-color: #f2f2f2;\n        }\n    }\n\n    @media (max-width: $mobile) {\n        tbody {\n            tr {\n                td {\n                    word-break: break-all;\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
